// TODO: These rebuttal items will eventually be configurable in admin.
// For now they are defined here as a static config.

export type CancelOptionRebuttal = {
  title: string;
  preCard: string;
  postCard?: string;
  buttonText: string;
  items: string[];
};

export type CancelOption = {
  id: string;
  label: string;
  rebuttal?: CancelOptionRebuttal;
};

const shuffleArray = <T>(array: T[]): T[] => {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

export const cancelOptions: CancelOption[] = [
  {
    id: 'expensive',
    label: 'It costs too much right now.',
    rebuttal: {
      title: 'That grocery run has a way of adding up.',
      preCard: 'Purple Carrot helps manage that grocery and food delivery bill each week.',
      postCard: 'This is the best way to get a week of plant-based meals with the recipes, portions, and ingredients already worked out.',
      buttonText: 'Make My Food Spend Work Harder',
      items: [
        'You\'ll no longer avoid extra trips to the grocery store.',
        'You may spend more each week overbuying food.',
        'You\'ll have to plan plant-based meals from scratch every time.',
      ],
    },
  },
  {
    id: 'my_own',
    label: 'I prefer to shop and cook on my own.',
    rebuttal: {
      title: 'Doing it yourself is one thing - \ndoing it all every week is another.',
      preCard: 'Purple Carrot keeps a full week of plant-based meals planned, shopped, and ready to make.',
      postCard: 'Cooking on your own doesn\'t need to mean rebuilding your whole routine from scratch.',
      buttonText: 'Keep The Week Handled',
      items: [
        'You lose access to pre-planned meals every week.',
        'You\'ll need to shop every week yourself.',
        'You won\'t have ready-to-make meals sitting in your fridge.',
      ],
    },
  },
  {
    id: 'not_excited',
    label: 'I\'m not excited by the meals.',
  },
  {
    id: 'dietary',
    label: 'The meals don\'t fit my nutrition needs.',
  },
  {
    id: 'order_issue',
    label: 'I had an issue with my order.',
  },
  {
    id: 'not_using_enough',
    label: 'I\'m not using Purple Carrot enough.',
  },
  {
    id: 'account_issue',
    label: 'I had an account or billing issue.',
  },
  {
    id: 'packaging_issue',
    label: 'I\'m concerned about packaging.',
  },
  {
    id: 'other',
    label: 'Something Else',
    rebuttal: {
      title: 'Keep food you feel good about within reach.',
      preCard: 'Purple Carrot helps you stay stocked with plant-based meals that are ready to make, so the week doesn\'t slip into last-minute delivery, scattered grocery runs, or whatever\'s easiest in the moment.',
      buttonText: 'Keep The Week Feeling Good',
      items: [
        'You\'ll have to plan your meals every day.',
        'You may find cooking the same recipes more routine and boring.',
        'You may reach for last-minute conveniences to compensate.',
      ],
    },
  },
];

export const getOptionsForCancel = (): CancelOption[] => {
  const other = cancelOptions.find((o) => o.id === 'other')!;
  const reasons = cancelOptions.filter((o) => o.id !== 'other');
  return shuffleArray(reasons)
    .concat(other);
};
